var _rect, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPhoneLogo = function SvgPhoneLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.395996,
    width: 80,
    height: 79.2079,
    rx: 39.604,
    fill: "#EAEAF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0004 79.5008C74.628 79.5008 80.0008 74.128 80.0008 67.5004C80.0008 60.8728 74.628 55.5 68.0004 55.5C61.3728 55.5 56 60.8728 56 67.5004C56 74.128 61.3728 79.5008 68.0004 79.5008Z",
    fill: "#FDBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 60.9863H69.5L68.7424 70.1977H67.197L66.5 60.9863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0003 74.0142C68.7601 74.0142 69.3761 73.3983 69.3761 72.6385C69.3761 71.8786 68.7601 71.2627 68.0003 71.2627C67.2405 71.2627 66.6245 71.8786 66.6245 72.6385C66.6245 73.3983 67.2405 74.0142 68.0003 74.0142Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 52.8745C37.8853 52.8745 37.5356 53.0194 37.2777 53.2772C37.0199 53.5351 36.875 53.8848 36.875 54.2495C36.875 54.6142 37.0199 54.9639 37.2777 55.2218C37.5356 55.4796 37.8853 55.6245 38.25 55.6245H43.75C44.1147 55.6245 44.4644 55.4796 44.7223 55.2218C44.9801 54.9639 45.125 54.6142 45.125 54.2495C45.125 53.8848 44.9801 53.5351 44.7223 53.2772C44.4644 53.0194 44.1147 52.8745 43.75 52.8745H38.25Z",
    fill: "#9498B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8125 19.8745C33.1715 19.8745 31.5977 20.5264 30.4373 21.6868C29.2769 22.8472 28.625 24.421 28.625 26.062V54.937C28.625 56.578 29.2769 58.1519 30.4373 59.3122C31.5977 60.4726 33.1715 61.1245 34.8125 61.1245H47.1875C48.8285 61.1245 50.4023 60.4726 51.5627 59.3122C52.7231 58.1519 53.375 56.578 53.375 54.937V26.062C53.375 24.421 52.7231 22.8472 51.5627 21.6868C50.4023 20.5264 48.8285 19.8745 47.1875 19.8745H34.8125ZM32.75 26.062C32.75 24.9235 33.674 23.9995 34.8125 23.9995H36.875V24.687C36.875 25.8255 37.799 26.7495 38.9375 26.7495H43.0625C44.201 26.7495 45.125 25.8255 45.125 24.687V23.9995H47.1875C48.326 23.9995 49.25 24.9235 49.25 26.062V54.937C49.25 56.0755 48.326 56.9995 47.1875 56.9995H34.8125C34.2655 56.9995 33.7409 56.7822 33.3541 56.3954C32.9673 56.0086 32.75 55.484 32.75 54.937V26.062Z",
    fill: "#9498B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(56 55.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phoneLogo.fe63c7e47a08d93c2ae2823d399934f1.svg";